import { getApiKey } from "../../../utils/apiKey";
import React from "react";
import { createGlobalStyle } from "styled-components";
import { apiCall_domainV2 } from "../../api";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { toast } from "react-hot-toast";

class MoreDetail extends React.Component {
  state = {
    offCode: null,
    loading: false,
    copied: false,
  };
  giftSubmitHandler = () => {
    this.setState({ loading: true }, () => {
      const headers = {
        Authorization: getApiKey(),
        "content-type": "application/json",
      };
      axios
        .post(
          `${apiCall_domainV2}/customer/market/submit_customer_gift`,
          {
            gift_id: this.props.detailData.id,
          },
          { headers }
        )
        .then((res) => {
          this.setState({
            offCode: res.data.data.discount_code,
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };
  copyCode = () => {
    try {
      navigator.clipboard.writeText(this.state.offCode);
      toast.success("کد کپی شد");
    } catch {
      toast.error("کد کپی نشد");
    }
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #262626;
    }`;
    const { handleModalDisplay } = this.props;
    return (
      <div className="aboutBazarcheContainer">
        <GlobalStyles />
        <div>
          <span>جزییات دریافت کد تخفیف</span>
          <i className="icon-times" onClick={handleModalDisplay} />
        </div>
        {this.props.detailData ? (
          <div className="aboutBazarche">
            <p>{this.props.detailData.title}</p>
            <p>{this.props.detailData.text}</p>
            <p className="expireTime">
              اعتبار تا {this.props.detailData.expire_time}
            </p>
            <p>
              به ازای {this.props.detailData.required_points} امتیاز میتوانید
              این کد تخفیف را دریافت کنید
            </p>
          </div>
        ) : (
          <></>
        )}
        {this.state.offCode ? (
          <button className="aboutBazarcheBtn copyCode" onClick={this.copyCode}>
            <i className="icon-copy" /> {this.state.offCode}
          </button>
        ) : (
          <button className="aboutBazarcheBtn" onClick={this.giftSubmitHandler}>
            {this.state.loading ? (
              <PulseLoader color="#fff" size={10} />
            ) : (
              " دریافت ک تخفیف"
            )}
          </button>
        )}
      </div>
    );
  }
}
export default MoreDetail;
